import { render, staticRenderFns } from "./UnpairedDatasetElementView.vue?vue&type=template&id=f2481e40"
import script from "./UnpairedDatasetElementView.vue?vue&type=script&lang=js"
export * from "./UnpairedDatasetElementView.vue?vue&type=script&lang=js"
import style0 from "./UnpairedDatasetElementView.vue?vue&type=style&index=0&id=f2481e40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports